const ALERT_AUTO_DISMISS_DELAY = 8;

export {
  ALERT_AUTO_DISMISS_DELAY
};